import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'formly-toggle-input',
    templateUrl: "./formly-toggle-input.component.html",
    standalone: false
})
export class FormlyToggleInputComponent extends FieldType implements OnInit, OnDestroy {
    param: any;
    isFormSubmitted: boolean = false;
    formSubmissionSubscription: Subscription;
    fieldKey: string;
    wrapperClass: string;
    enableBigToggle = true;
    extraMessage = '';
    
    constructor(private dynamicFormService: DynamicFormService,private sanitizer: DomSanitizer) {
        super();
    }

    ngOnInit() {
        if (this.to.options && this.to.options[0] && this.to.options[0].wrapperClass) {
            this.wrapperClass = this.to.options[0].wrapperClass;
        }
        else {
            this.wrapperClass = "d-flex justify-content-between pt-3 pb-1  pl-3";
        }
        if (this.to.options && this.to.options[0] && this.to.options[0].enableBigToggle != undefined){
            this.enableBigToggle = this.to.options[0].enableBigToggle;
        }
        if (this.field.key) {
            this.fieldKey =this.field.id??this.field.key.toString();
        }
        if(this.to.options && this.to.options[0] && this.to.options[0].extraMsgHtml)
        {
            this.extraMessage = this.to.options[0].extraMsgHtml;
        }
        this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
            this.isFormSubmitted = data;
        });
    }
    sanitizerHtml(element) {
        return this.sanitizer.bypassSecurityTrustHtml(element);
      }
    
    ngOnDestroy() {
        if (this.formSubmissionSubscription) {
            this.formSubmissionSubscription.unsubscribe();
        }
    }

    onValueChange() {
        this.to.change(this.field, this.formControl.value);
    }

}